// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Rfui","location":"Header_location__3zutk"};